/**
 * Stripe Singleton Helper
 * 
 * Provides a single instance of Stripe across the application.
 * Uses @stripe/stripe-js loadStripe which handles:
 * - Async script loading
 * - Caching (only loads once)
 * - Promise-based initialization
 * 
 * Usage:
 *   import { getStripe } from '../helpers/stripe';
 *   <Elements stripe={getStripe()}>
 */
import { loadStripe } from '@stripe/stripe-js';
import { payment } from '../config';

let stripePromise = null;

/**
 * Get the Stripe instance (singleton pattern)
 * @returns {Promise<Stripe>} Stripe instance promise
 */
export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(payment.stripe.publishableKey);
  }
  return stripePromise;
};

export default getStripe;
